import { purchaseOrderFileIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const deletePurchaseOrderFile = {
  name: "deletePurchaseOrderFile" as const,
  input: z.object({ fileId: purchaseOrderFileIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
